<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<template>
  <a
    class="text-sm font-medium leading-[1.43] text-main-blue underline"
    href="#"
    style="text-decoration-style: dashed;"
  >
    {{ title }}
  </a>
</template>
